// Selectors


import { RootState } from '../../store';

export const credentialTypeSearchFormSelector = (state: RootState) => state.credentialTypeSearchFormState
